import { NextPageContext } from "next";
import Layout from "../components/Layout";
import CollectionFeatures from "../components/collection/Features";
import { addApolloState, initializeApollo } from "../graphql/client";
import {
  GetVehiclesDocument,
  GetVehiclesQuery,
} from "../graphql/generated/graphql";
import { TIER_KEYS } from "../utils/constants";
import Grid from "../components/Grid";
import CollectionServices from "../components/collection/Services";
// import CollectionContact from "../components/collection/Contact";
import GoToWatchlistCard from "../components/GoToWatchlistCard";
import Link from "next/link";
import CollectionSubscriptionSection from "../components/collection/SubscriptionSection";
import SEO from "../components/SEO";
import { COLLECTION_DESCRIPTION } from "../components/collection/Banner";

export default function CollectionPage({ vehicles }) {
  return (
    <div className="pt-4">
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/collection-acerca-de`}
        title={`Collection by Movi - Acerca de`}
        description={COLLECTION_DESCRIPTION}
        siteTitle="Movi Autos"
      />
      <CollectionFeatures />
      <CollectionServices />
      <div className="mt-8 mb-16">
        <Grid
          items={vehicles}
          title={
            <div className="mx-auto max-w-2xl lg:mx-0">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Autos disponibles
              </h2>
              <p className="mt-6 text-lg font-normal leading-8 text-gray-600">
                Estos son algunos de los autos que forman parte de Collection by
                Movi.
                <Link
                  href="/collection"
                  // onClick={() => trackBannerClick(trackId)}
                  className="ml-1"
                >
                  <span className="font-semibold leading-6 text-orange-500 hover:text-orange-400">
                    Ver todos
                    <span aria-hidden="true">→</span>
                  </span>
                </Link>
              </p>
            </div>
          }
          LastElement={() => (
            <GoToWatchlistCard
              pathname="/collection"
              icon="list"
              label="Ver todos"
            />
          )}
        />
      </div>
      <CollectionSubscriptionSection vehicleId={null} />
      {/* <CollectionContact /> */}
    </div>
  );
}

CollectionPage.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export const getStaticProps = async (context: NextPageContext) => {
  const { query } = context;
  const apolloClient = initializeApollo();

  try {
    const getVehiclesCollection = await apolloClient.query<GetVehiclesQuery>({
      query: GetVehiclesDocument,
      variables: {
        limit: 9,
        filters: {
          listingTier: TIER_KEYS.COLLECTION,
        },
      },
    });

    const { data: collectionData } = getVehiclesCollection;
    const { getVehicles: getCollectionVehicles } = collectionData || {};
    const { data: vehicles } = getCollectionVehicles || {};

    return addApolloState(apolloClient, {
      props: {
        vehicles: vehicles || [],
      },
    });
  } catch (e) {
    return {
      props: {
        vehicles: [],
      },
    };
  }
};
